<script>

import { apiClient } from '@services'
import { notificationService } from '@services/'
import moment from 'moment'
import { SweetModal } from 'sweet-modal-vue'
import Loader from '@components/loader/loader'
import VueLoader from '@components/loader/VueLoader'
import {
  CAMPAIGN_ID,
  CAMPAIGN_ID_DUPLICATE,
} from '../constants/endponts'
import { mapMutations } from 'vuex'
export default {
  components: { SweetModal, Loader, VueLoader },
  props: {
    page: {
      type: String,
      default: '',
    },
    breadcrumbsList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      totalNotifications: 2,
      currentRoute: null,
      projectsRoute: false,
      project: null,

      projectId: this.$route.params.projectId,
      campaignId: this.$route.params.campaignId,
      campaign: null,
      loaderRemove: false,
      campaignsBreadcrumbs: [
        {
          path: '/projects/'+ this.$route.params.projectId +'/email-campaigns',
          name: 'CampaignList',

        },
        {
          path: '/projects/'+ this.$route.params.projectId +'/campaign/'+ this.$route.params.campaignId +'/performance-overview',
          name: 'Performance',
        },
       {
          path: '/projects/'+ this.$route.params.projectId +'/campaign/'+ this.$route.params.campaignId +'/sequence',
          name: 'Sequence',
        },
        {
          path: '/projects/'+ this.$route.params.projectId +'/campaign/'+ this.$route.params.campaignId +'/recipients',
          name: 'Recipients',
        },
      ],
      createBreadcrumbs: [
        {
          path: '/projects/'+ this.$route.params.projectId +'/email-campaigns',
          name: 'CampaignList',

        },
       {
          path: '/projects/'+ this.$route.params.projectId +'/campaign/'+ this.$route.params.campaignId +'/sequence',
          name: 'Campaign (Draft)',
        },
      ],
    }
  },
  created() {
    this.loader = true
    this.getCampaign()
      .then((res) => {
      })
      .then(() => {
        this.loader = false
      })

    if(this.breadcrumbsList) {
      this.campaignsBreadcrumbs = this.breadcrumbsList
    }
  },
  methods: {
    ...mapMutations({
      updateForm: 'campaigns/UPDATE_CAMPAIGN_FORM',
      openModal: 'campaigns/OPEN_MODAL',
      closeModal: 'campaigns/CLOSE_MODAL',
      changeLoading: 'campaigns/LOADING',
    }),

    getCampaign() {
      return apiClient
        .get(CAMPAIGN_ID(this.campaignId))
        .then(
          (res) => {
            this.campaign = res.data
            this.project = res.data.app
          },
          (res) => {
            notificationService.handleResponse(res)
          }
        )
        .catch((err) => {
          console.log('error', err)
          notificationService.handleResponse(err)
          return err
        })
    },
    goToCampaigns(){
       this.$router.push('/projects/'+ this.projectId +'/email-campaigns')
    },
    saveCampaign(){
      this.$parent.saveAndClose()
    }
  },
  // computed: {
  //   ...authComputed,
  // },
}
</script>
<template>

  <div class="container-fluid bg-white">
      <div
        class="d-flex align-items-center justify-content-between py-3 px-2 mb-1"
      >
        <div>
          <nav aria-label="breadcrumb">
            <ol
                v-if="page !== 'Create'"
                class="breadcrumb m-0 p-0"
            >
              <li
                v-for="(item, index) in campaignsBreadcrumbs"
                :key="index"
                class="h6 font-weight-bold m-0 mr-3"
              >
                <a :href="item.path">

                  <small v-if=" index === 0" class="text-black mr-3">
                    <BaseIcon name="angle-double-left"/>
                  </small>

                  <span v-else>
                    <span v-if=" item.name === page" class="text-purple">
                      {{ item.name }}
                    </span>
                    <span v-else  class="text-black">
                      {{ item.name }}
                    </span>
                  </span>
                </a>
              </li>
            </ol>
            <ol
                v-else
                class="breadcrumb m-0 p-0"
            >
              <li
                v-for="(item, index) in createBreadcrumbs"
                :key="index"
                class="h6 font-weight-bold m-0 mr-3"
              >
                  <small v-if=" (index === 0)" class="text-black mr-3">
                    <a :href="item.path">
                      <BaseIcon name="angle-double-left" class="text-black mr-3"/>
                    </a>
                  </small>

                  <span v-else-if=" (index === 1)">
                    <span class="text-purple">
                      {{ item.name }}
                    </span>
                  </span>

                  <span v-else>
                    <span v-if=" item.name === page" class="text-black">
                      {{ item.name }}
                    </span>
                    <span v-else  class="text-gray-light">
                      {{ item.name }}
                    </span>
                  </span>
              </li>
            </ol>
          </nav>
        </div>

        <button
          v-if="(page === 'Sequence') || (page === 'Create')"
          class="font-weight-normal btn btn-secondary text-white px-4"
          @click="saveCampaign"
        >
          <!--<BaseIcon name="plus" />-->
          Save & Close
        </button>
      </div>
    </div>




</template>
